<mat-card>
  <mat-card-content>
    <div [style.display]="dataUrl ? 'flex' : 'none'" class="pdf-preview">
      <button mat-flat-button color="primary" (click)="onGenerateInvoice()">Télécharger la facture</button>
      <iframe id="pdfPreview" src="" width="100%" height="90%"></iframe>
    </div>
    <span [style.display]="!dataUrl ? 'flex' : 'none'" class="no-pdf">Aucune facture générée. Cliquez sur générer la facture</span>
  </mat-card-content>
</mat-card>
